import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { RecuperarContrasenaService } from '../_services';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-recupera-contrasena',
  templateUrl: './recupera-contrasena.component.html',
  styleUrls: ['./recupera-contrasena.component.css']
})
export class RecuperaContrasenaComponent implements OnInit {
  formRecuperar: FormGroup;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private recuperarContrasenaService: RecuperarContrasenaService) { }

  ngOnInit() {
    this.formRecuperar = this.formBuilder.group({
      username: ['', Validators.required]
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.formRecuperar.controls;
  }
  onSubmit() {
    this.submitted = true;
    console.log('Submit form recuperar contraseña');
    // stop here if form is invalid
    if (this.formRecuperar.invalid) {
      return;
    }

    this.recuperarContrasenaService
      .postRecuperarContrasena(this.f.username.value)
      .pipe(first())
      .subscribe(
        data => {
          if (data['id']) {
            alert('Recibirá un email con la contraseña nueva');
            this.submitted = false;
            this.f.username.setValue('');
          } else {
            alert('Usuario no válido: ' + data['message']);
            this.submitted = false;
          }
        }
      );
  }

}
